// src/pages/TrainingDetails.js
import React from 'react';
import { useParams } from 'react-router-dom';

function TrainingDetails() {
  const { id } = useParams();

  return (
    <div>
      <h1>Training Details</h1>
      <p>Details for training ID: {id}</p>
      {/* Add components to show training details, upload documents, etc. */}
    </div>
  );
}

export default TrainingDetails;
